import { Component, OnInit, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';

// MODELOS
// RUTAS

// COMPONENTES

// SERVICIOS
import { AuthenticationService } from './../../../services/authentication.service';
import { StorageService } from 'src/app/services';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.css']
})
export class SideMenuComponent implements OnInit {
  currentUser: string;
  constructor(
    private router: Router
    , private elRef: ElementRef
    , public deviceService: DeviceDetectorService
    , private storageService : StorageService
    , private authenticationService: AuthenticationService,
    ) { 
      console.log("const menu");
      console.log(this.currentUser);
      this.authenticationService.currentUserEmail.subscribe(x => this.currentUser = x);
    }

  ngOnInit() {    
    this.currentUser = this.storageService.getStorage('email');
    //this.authenticationService.currentUserEmail.subscribe(x => this.currentUser = x);
    // const numbers = timer(8000);
    // numbers.subscribe(any => this.authenticationService.currentUserEmail.subscribe(x => this.currentUser = x));
    // numbers.subscribe(any => console.log(this.currentUser));
    // console.log(this.currentUser);
  }

  RemoveActiveMenuClass(className: string) {
    // obtenemos todos los navlinks con la clace active color
    let nativeElement: HTMLElement = this.elRef.nativeElement;
    let navLinks = nativeElement.getElementsByClassName(className);

    // le quitamos la clase, para indicar que ya no estan activos
    for (let i = 0; i < navLinks.length; i++) {
      navLinks.item(i).classList.remove(className);
    }
  }

  AddActiveMenuClass(event: any, className: string) {

    this.RemoveActiveMenuClass(className);

    // le añadimos la clase active al navlink que fue presionado
    event.target.classList.add(className);

  }

  GoToCompanyLog() {
    this.router.navigateByUrl('/search/companylog');
  }

  GoToBPLog() {
    this.router.navigateByUrl('/search/bplog');
  }

  GoToSupplierLog() {
    this.router.navigateByUrl('/search/supplierlog');
  }

  GoToCreateAlert() {
    this.router.navigateByUrl('/config/Alert');
  }

  GoToCreateCompany() {
    this.router.navigateByUrl('/config/Company');
  }

  GoToAssignAlertToCompany() {
    this.router.navigateByUrl('/config/AssingAlertToCompany');
  }

  GoToManager() {
    this.router.navigateByUrl('/config/Manager');
  }

  GoToManagerByCompany() {
    this.router.navigateByUrl('/config/ManagerByCompany');
  }

  GoToCreateTransact() {
    this.router.navigate(['/', 'transacts']);
  }

  GoToSearchTransact() {
    this.router.navigate(['/', 'transact-search']);
  }

  GoToConfigs() {
    this.router.navigate(['/', 'configs']);
  }

  logout() {
    this.authenticationService.logout();    
  }
  
}
